import { Controller } from '@hotwired/stimulus'

// Keeps the Waivers totals in step with the table as live signatures
// are prepended and check-ins replace or remove rows.
export default class extends Controller {
  static targets = ['rows', 'waivers', 'minors']

  // initialize, not connect: Stimulus fires rowsTargetConnected before connect
  initialize() {
    this.observer = new MutationObserver(() => this.recount())
  }

  disconnect() {
    this.observer.disconnect()
  }

  // The datatable controller swaps the tbody out when it rebuilds after a
  // stream, so the observer follows whichever tbody is current.
  rowsTargetConnected(rows) {
    this.observer.disconnect()
    this.observer.observe(rows, { childList: true })
    this.recount()
  }

  recount() {
    const rows = [...this.rowsTarget.querySelectorAll('tr')]
    this.waiversTarget.textContent = rows.length
    this.minorsTarget.textContent = rows.reduce((sum, row) => sum + Number(row.dataset.minors || 0), 0)
  }
}
